import { Component, OnInit, OnDestroy } from '@angular/core';
import { AppService } from '../../../../app.service';
import { SearchItem } from '../../../../entities';
import { FindInspectionService } from '../../services/find-inspection.service';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { NotificationsService } from 'angular2-notifications';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { SortOptions, OrderInspectionBy, InspectionRowViewModel } from '../../models/find-inspection.model';
import { PageEvent } from '@angular/material/paginator';
import { trigger, transition, style, animate } from '@angular/animations';

@Component({
  selector: 'repair-estimate-list-table',
  templateUrl: './repair-estimate-list-table.component.html',
  styleUrls: ['./repair-estimate-list-table.component.scss'],
   animations: [
      trigger(
        'fadeIn', [
          transition(':enter', [
            style({ opacity: 0 }),
            animate('500ms', style({ opacity: 1 }))
          ]),
          transition(':leave', [
            style({ opacity: 1 }),
            animate('500ms', style({ opacity: 0 }))
          ])
        ]
      )]
})
export class RepairEstimateListTableComponent implements OnInit, OnDestroy {
  public pageNumber = 0;
  public inspectionsPerPage = 25;
  public totalResults = 0;
  public inspectionResults: InspectionRowViewModel[] = [];
  public retrievingInspectionResults = true;

  private subscriptions: Subscription[] = [];
  private lastItemsSearched: SearchItem[] = [];




  sortOption: SortOptions;


  evalOrder: OrderInspectionBy = new OrderInspectionBy(SortOptions.Eval);
  dateOrder: OrderInspectionBy = new OrderInspectionBy(SortOptions.InspectionDate, true);
  serialOrder: OrderInspectionBy = new OrderInspectionBy(SortOptions.SerialNumber);
  uitOrder: OrderInspectionBy = new OrderInspectionBy(SortOptions.UnitNumber);
  customerOrder: OrderInspectionBy = new OrderInspectionBy(SortOptions.Customer);
  jobsiteOrder: OrderInspectionBy = new OrderInspectionBy(SortOptions.Jobsite);
  modelOrder: OrderInspectionBy = new OrderInspectionBy(SortOptions.Model);
  makeOrder: OrderInspectionBy = new OrderInspectionBy(SortOptions.Make);
  familyOrder: OrderInspectionBy = new OrderInspectionBy(SortOptions.Family);



  statusOrder: OrderInspectionBy = new OrderInspectionBy(SortOptions.Status);

  constructor(private _appService: AppService,
    private _findInspectionService: FindInspectionService,
    private _notify: NotificationsService,
    private activatedRoute: ActivatedRoute,
    private _router: Router, ) { }

  ngOnInit() {
    this._appService.setPageTitle('Find Inspection');
    this._appService.setShowSearchComponentDateInputs(true);
    this.initializeResultsList();

    console.log("rpe");
  }

  /**
   * Unsubscribe from all our subscriptions before leaving
   * the page.
   */
  ngOnDestroy() {
    this._appService.setShowSearchComponentDateInputs(false);
    this.subscriptions.forEach(
      subscription => {
        if (!subscription.closed) subscription.unsubscribe();
      });
  }

  /**
   * Setup the subscripton to the url query paramters. So any time
   * the user changes the page or number of results, or the user
   * navigates back or forward, the page will reload the correct
   * search results.
   */
  initializeQueryParamterSubscription() {
    this.subscriptions.push(
      this.activatedRoute.queryParams.subscribe(
        params => {
          const pageNumber: number = params['page'];
          const inspectionsPerPage: number = params['display'];
          if (pageNumber != null) {
            this.pageNumber = pageNumber - 1;
          } else {
            this.pageNumber = 0;
          }

          if (inspectionsPerPage != null) {
            this.inspectionsPerPage = inspectionsPerPage;
          } else {
            this.inspectionsPerPage = 25;
          }

          this.loadInspectionResults(this.lastItemsSearched, this.dateOrder);
        })
    );
  }

  /**
   * Updates the route query paramters based on the current page selected and
   * the number of inspections being shown per page.
   */
  updateQueryParams() {
    const queryParams: Params = Object.assign({}, this.activatedRoute.snapshot.queryParams);
    queryParams['page'] = this.pageNumber + 1;
    queryParams['display'] = this.inspectionsPerPage;
    this._router.navigate(
      [],
      {
        relativeTo: this.activatedRoute,
        queryParams: queryParams
      });
  }

  /**
   * This is called every time the page number or the number of records
   * per page is changed by the user.
   * @param event The data about what changed.
   */
  onPageEvent(event: PageEvent) {
    this.pageNumber = event.pageIndex;
    this.inspectionsPerPage = event.pageSize;
    this.updateQueryParams();
  }

  /**
   * Subscribes to the search component changes. Every time the user searches
   * something new this component will call the server for a new set of results.
   */
  private initializeResultsList() {
    this.lastItemsSearched = this._appService.getLastSelectionSearchItems();
    this.initializeQueryParamterSubscription();
    this.subscriptions.push(
      this._appService.getSelectionSearchItems().subscribe(
        searchItems => {
          this.pageNumber = 0; // Reset the page to 0 after a search
          this.updateQueryParams(); // Update the query paramters now that we are setting the page back to 0
          this.loadInspectionResults(searchItems, this.dateOrder);
        })
    );
  }

  /**
   * Retrieves the inspections based on the users search parameters entered
   * into the shared search component.
   * @param params The searcg component paramters (used to filter the search).
   */
  public loadInspectionResults(params: SearchItem[], orderby: OrderInspectionBy) {
    console.log("params_xxx",params)
    this.retrievingInspectionResults = true;
    this.lastItemsSearched = params;
    this.subscriptions.push(this._findInspectionService
      .getAllRepairEstimates(this.pageNumber, this.inspectionsPerPage, params, orderby)
      .subscribe(
      results => {
        console.log(results);
        this.inspectionResults = results.repairEstimatesData;
        console.log(this.inspectionResults);
        this.totalResults = results.TotalRecords;
      },
      error => {
        console.log(error);
        this._notify.error('Error', 'Unable to search for inspections. Please contact TrackTreads support if this error continues to happen. ');
      },
      () => {
        this.retrievingInspectionResults = false;
      })
    );
  }
 
  openInspection(inspection:any) {
    console.log("inspection",inspection)
    let sysTypeId = inspection.IsChain == true ? 1:2

    if(inspection.IsFrame ==false){
      //this._router.navigate(['/repair-estimate', this.inspectionId,sysTypeId]);
      window.open('/repair-estimate/' + inspection.Id + '/' + sysTypeId, '_blank');
    }
    else{
      //this._router.navigate(['/repair-estimate-frame', this.inspectionId, 3]);
      window.open('/repair-estimate-frame/' + inspection.Id + '/3', '_blank');
    }
  }
  sortBy(sortOption: string) {
    const selectedOptions = SortOptions[sortOption];

    switch (selectedOptions) {
      case SortOptions.Eval:
        this.evalOrder.selected = !this.evalOrder.selected;
        this.loadInspectionResults(this.lastItemsSearched, this.evalOrder);
        break;
      case SortOptions.InspectionDate:
        this.dateOrder.selected = !this.dateOrder.selected;
        this.loadInspectionResults(this.lastItemsSearched, this.dateOrder);
        break;
      case SortOptions.SerialNumber:
        this.serialOrder.selected = !this.serialOrder.selected;
        this.loadInspectionResults(this.lastItemsSearched, this.serialOrder);
        break;
      case SortOptions.UnitNumber:
        this.uitOrder.selected = !this.uitOrder.selected;
        this.loadInspectionResults(this.lastItemsSearched, this.uitOrder);
        break;
      case SortOptions.Customer:
        this.customerOrder.selected = !this.customerOrder.selected;
        this.loadInspectionResults(this.lastItemsSearched, this.customerOrder);
        break;
      case SortOptions.Jobsite:
        this.jobsiteOrder.selected = !this.jobsiteOrder.selected;
        this.loadInspectionResults(this.lastItemsSearched, this.jobsiteOrder);
        break;
      case SortOptions.Model:
        this.modelOrder.selected = !this.modelOrder.selected;
        this.loadInspectionResults(this.lastItemsSearched, this.modelOrder);
        break;
      case SortOptions.Make:
        this.makeOrder.selected = !this.makeOrder.selected;
        this.loadInspectionResults(this.lastItemsSearched, this.makeOrder);
        break;
      case SortOptions.Family:
        this.familyOrder.selected = !this.familyOrder.selected;
        this.loadInspectionResults(this.lastItemsSearched, this.familyOrder);
        break;
      case SortOptions.Status:
        this.statusOrder.selected = !this.statusOrder.selected;
        this.loadInspectionResults(this.lastItemsSearched, this.statusOrder);
        break;
    }

  }
}
